<template>
    <div>
        <b-button variant="primary" v-if="manage" v-b-modal.upload-file-ocr-modal>
            <span class="text-nowrap">Upload file</span>
        </b-button>
        <b-modal id="upload-file-ocr-modal" hide-footer size="lg" centered title="Upload file" @hidden="resetModal">
            <div class="modal_content">
                <b-alert dismissible :show="hasError" class="p-1" variant="danger" @dismissed="clearErrorMsg">{{
                    errorMsg }}</b-alert>

                <div class="pt-10 text-center" v-if="text == ''">
                    <feather-icon @click="$refs.ref_Input.click()" icon="UploadIcon" size="50"
                        class="qu-icon-grey curser-pointer" />

                    <input ref="ref_Input" type="file" accept="image/*,application/pdf,application/msword,
                            application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                            text/csv,application/vnd.ms-excel,
                            application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="d-none"
                        @change="ImageRendererItems" />
                </div>
                <div v-else>
                    {{ text }}
                </div>

                <div class="modal-footer">
                    <b-button @click="createOcr" :disabled="loading" variant="primary">
                        <b-spinner v-if="loading" small class="mr-1" />
                        Convert
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {
    BButton,
    BFormInput,
    BFormGroup,
    BAlert,
    BSpinner,
    BFormTextarea,
} from "bootstrap-vue";
import axios from "axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
export default {
    components: {
        vSelect,
        BButton,
        BFormInput,
        BFormGroup,
        BAlert,
        BSpinner,
        ToastificationContent,
        BFormTextarea,
    },
    data() {
        return {
            text: "",
            errorMsg: "",
            loading: false,
            alertMessageToast: "",
            audioSource: null,
        };
    },
    computed: {
        hasError() {
            return this.errorMsg != "";
        },
    },
    methods: {
        showToast(variant) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: "Notification",
                    icon: "BellIcon",
                    text: this.alertMessageToast,
                    variant,
                },
            });
        },
        clearErrorMsg() {
            this.errorMsg = "";
        },
        resetModal() {
            this.text = "";
            this.errorMsg = "";
        },
        async createTts() {
            let status = await this.checkValidation();
            if (!status) {
                return;
            }
            this.audioSource = null;
            this.loading = true;
            try {
                let ttsData = {
                    text: this.text,
                    voice: this.voice.value,
                };
                const resp = await axios.post(
                    process.env.VUE_APP_API_URL + "/audio",
                    ttsData,
                    {
                        headers: {
                            Authorization: this.token,
                        },
                    }
                );

                if (resp.data.status === 200) {
                    (this.audioSource = resp.data.audio_url),
                        (this.loading = false);
                }
            } catch (error) {
                if (error.response) {
                    this.errorMsg =
                        error.response.data.error || "An error occurred";
                } else if (error.request) {
                    this.errorMsg =
                        "No response received from server. Please check your network connection.";
                } else {
                    this.errorMsg =
                        "Error in setting up the request: " + error.message;
                }
                this.loading = false;
                this.alertMessageToast = this.errorMsg;
                this.showToast("danger");
            }
        },

        async uploadFile(file, url, key, ext) {
            try {
                const response = await axios.put(url, file, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": file.type,
                    },
                });

                if (response.status !== 200) {
                    console.error("Error uploading file:", response);
                }
                // let s3Url =
                //     "https://zape02.s3.ap-southeast-1.amazonaws.com/" + key;
                this.createOcr(key);
            } catch (error) {
                console.error("Error uploading file:", error);
            }
        },
        async ImageRendererItems(event) {
            this.loading = true;
            const file = event.target.files[0];
            const validTypes = [
                "image/png", "image/jpeg", "image/jpg", "image/gif", "image/svg+xml",
                "application/pdf", "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "text/csv", "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            ];

            if (!validTypes.includes(file.type)) {
                alert("Invalid file type.");
                this.$refs.ref_Input.value = null;
                return;
            }

            if (file) {
                let fileExtension = this.getFileExtension(file.type);
                try {
                    const response = await axios.post(
                        process.env.VUE_APP_API_URL +
                        "/s3/generate-presigned-url",
                        {
                            type: file.type,
                            ext: fileExtension,
                        },
                        {
                            headers: {
                                Authorization: this.token,
                            },
                        }
                    );
                    const { url, key } = response.data;
                    let extention = fileExtension;
                    await this.uploadFile(file, url, key, extention);
                } catch (error) {
                    console.error("Error getting pre-signed URL:", error);
                }
            }
            event.target.value = null;
        },

        async createOcr(url) {
            try {
                const response = await axios.post(
                    process.env.VUE_APP_API_URL +
                    "/ocr/create",
                    {
                        url,
                    },
                    {
                        headers: {
                            Authorization: this.token,
                        },
                    }
                );
                const { text } = response.data;
                this.text = text;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.error("Error getting pre-signed URL:", error);
            }
        },

        getFileExtension(mimeType) {
            const mimeToExtension = {
                "image/jpeg": "jpg",
                "image/png": "png",
                "image/gif": "gif",
                "image/svg+xml": "svg",
                ".svg": "svg",
                "application/json": "json",
                ".json": "json",
                ".lottie": "lottie",
                lottie: "lottie",
                "audio/mpeg": "mp3",
                "audio/wav": "wav",
                "audio/ogg": "ogg",
                "audio/aac": "aac",
                "audio/flac": "flac",
                "audio/x-wav": "wav",
                "audio/x-m4a": "m4a",
                "audio/webm": "webm",
            };
            return mimeToExtension[mimeType] || "png";
        },
        checkValidation() {
            if (!this.text.length) {
                this.errorMsg = "File required.";
                return;
            }

            return "ok";
        },
    },
    props: ["manage", "token"],
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.dropdown button {
    padding: 0 !important;
}

.dropdown-menu {
    min-width: 8rem;
    margin-top: -17px !important;
}

.dropdown a.dropdown-item {
    padding: 0px 8px;
}

.vs__open-indicator {
    fill: #9d9d9d;
}
</style>
